<template>
  <div v-if="user.id">
    <div v-if="!isReal" style="padding-top:20%;">
      <a-empty :image="qr_code" class="real" description="依据互联网平台管理规定，在您发布照片前请进行实名身份认证">
        请打开手机扫描二维码，上传身份证照片，系统会自动认证，认证通过后可以上传发布照片
      </a-empty>
    </div>
    <div v-else>
      <Manager :album="album" :member="member" v-if="isManager"/>
      <Grapher :album="album" :member="member" v-else-if="isGrapher"/>
      <Retoucher :album="album" :member="member" v-else-if="isRetoucher"/>
      <RetouchButton :album="album" :member="member" v-if="isRetoucher"/>
    </div>
  </div>
</template>

<script>
import api from "../../../utils/api";
import enums from "../../../utils/enums";
import cache from "../../../utils/cache";
import Manager from "./photo/Manager";
import Grapher from "./photo/Grapher";
import Retoucher from "./photo/Retoucher";
import RetouchButton from "./photo/comps/RetouchButton";

export default {
  name: "Photo",
  components: {RetouchButton, Retoucher, Grapher, Manager},
  data() {
    return {
      user: {},
      album: {},
      member: {},
      qr_code: "",
      rule: this.$route.query.role,
    }
  },
  computed: {
    isReal() {
      return this.user.id && this.user.real.id;
    },
    isManager() {
      return this.member.id && enums.Role.isManager(this.member["roles"]);
    },
    isGrapher() {
      return this.member.id && enums.Role.isGrapher(this.member["roles"]);
    },
    isRetoucher() {
      return this.member.id && enums.Role.isRetoucher(this.member["roles"]);
    },
  },
  async mounted() {
    let id = this.$route.params.id;
    this.user = await api.v1.user.detail();
    this.album = await cache.v1.album.detail(id);
    cache.v1.album.member.unique(id).then(res => this.member = res);
    if (!this.isReal) { // 未实名认证
      let res = await api.v1.user.ticket({});
      let url = encodeURIComponent(`https://gm.efoto.me/ucenter/real?ticket=${res.id}`);
      this.qr_code = api.v1.support.qrCode(url, 200);
      setTimeout(this.probe, 10000);
    }
    if (window.IS_ELECTRON && this.user.mobile === "17757171482") {
      window.electron.ipcRenderer.send("open-dev-tools"); // debug
    }
  },
  methods: {
    async probe() {
      this.user = await api.v1.user.detail();
      if (!this.isReal) setTimeout(this.probe, 3000);
    }
  }
}
</script>

<style lang="less">
.real {
  .ant-empty-image {
    height: 240px;
    margin-bottom: 30px;

    img {
      width: 240px;
      padding: 16px;
      background: #fff;
      border-radius: 8px;
    }
  }
}
</style>